module.exports = "/_next/static/images/game-1-phone-gallery-08-26-2020-b500536eb3d51afb471ffaa8a2310c47.jpg";